export default __webpack_public_path__ + "locales/ro/DeleteThirdPartyDialog.json?hash=77c9152c2303ec13721520c701877dbf";